import React from "react";
import {
    DollarOutlined,
    InboxOutlined,
    ClockCircleOutlined,
    SafetyOutlined,
    EnvironmentOutlined,
    GiftOutlined,
    PlusCircleOutlined,
    MinusCircleOutlined
} from "@ant-design/icons";
import {
    StatsGrid,
    StatCard,
    StatIconWrapper,
    StatContent,
    StatValue,
    StatLabel
} from "../styles/SubcompanyDetailTotal.styles";

const formatAmount = value => {
    if (value == null || value === "") return "0";
    const num = Number(String(value).replace(/\s/g, ""));
    return num.toLocaleString("tr-TR");
};

const STAT_CONFIG = [
    {
        key: "totalAmount",
        label: "Toplam Hakediş",
        icon: DollarOutlined,
        showTl: false,
        highlight: true,
        getSubLabel: d => d?.subCompanyCount != null && `${d.subCompanyCount} alt firma`
    },
    {key: "packageAmount", label: "Paket", icon: InboxOutlined, showTl: true},
    {key: "hourAmount", label: "Saatlik Ücret", icon: ClockCircleOutlined, showTl: true},
    {
        key: "hourlyGuaranteePackageAmount",
        label: "Saatlik Garanti",
        icon: SafetyOutlined,
        showTl: true
    },
    {key: "distanceAmount", label: "KM", icon: EnvironmentOutlined, showTl: false},
    {key: "bonusPackageAmount", label: "Paket Bonus", icon: GiftOutlined, showTl: true},
    {key: "additionAmount", label: "Eklenti", icon: PlusCircleOutlined, showTl: true},
    {key: "paycutAmount", label: "Kesinti", icon: MinusCircleOutlined, showTl: true}
];

export const SubcompanyDetailStats = ({data}) => {
    const stats = data;

    return (
        <StatsGrid>
            {STAT_CONFIG.map(({key, label, icon: Icon, showTl, highlight, getSubLabel}) => {
                const value = stats[key];
                const subLabel = (getSubLabel && getSubLabel(stats)) || label;
                const displayValue =
                    value != null ? `${formatAmount(value)}${showTl ? " TL" : ""}` : "0";

                return (
                    <StatCard key={key}>
                        <StatIconWrapper $highlight={highlight}>
                            <Icon />
                        </StatIconWrapper>
                        <StatContent>
                            <StatValue>{displayValue}</StatValue>
                            <StatLabel>{subLabel}</StatLabel>
                        </StatContent>
                    </StatCard>
                );
            })}
        </StatsGrid>
    );
};
